import React, { useState, useEffect } from "react";
import "./index.css";
import { useNavigate, useLocation } from "react-router-dom";
import { verify2FA } from "../../../../functions/auth";
import { toast } from "react-toastify";
import Loading from "../../../../modal/Loading";
import Cookies from "universal-cookie";

const BackupVerification = () => {
  const [backupCode, setBackupCode] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const cookies = new Cookies();
  const { data } = location.state || {};
  const tokenC = data?.token?.accessToken || cookies.get("token");
  const userNameC = cookies.get("userName");

  useEffect(() => {
    if (!tokenC) {
      navigate("/login", { replace: true });
      return;
    }
    if (!data && tokenC && userNameC) {
      navigate("/dashboard", { replace: true });
    }
  }, [tokenC, userNameC, navigate, data]);

  const handleBackupVerification = async (e) => {
    e.preventDefault();
    if (!backupCode || backupCode.length < 8) {
      toast.error("Please enter a valid backup code");
      return;
    }

    setLoading(true);
    try {
      const response = await verify2FA(tokenC, backupCode);
      
      const tokenPayload = response?.data?.token || data?.token;
      const userPayload = response?.data?.user || data?.user;

      if (tokenPayload) {
        cookies.set("token", tokenPayload.accessToken, {
          expires: new Date(new Date().getTime() + 7 * 60 * 60 * 1000),
          maxAge: 7 * 60 * 60,
        });
        cookies.set("refreshToken", tokenPayload.refreshToken, {
          expires: new Date(new Date().getTime() + 7 * 60 * 60 * 1000),
          maxAge: 7 * 60 * 60,
        });
      }

      if (userPayload) {
        cookies.set("userName", userPayload.email);
        cookies.set("userId", userPayload.id);
        cookies.set("name", userPayload.name);
        localStorage.setItem("userData", JSON.stringify(userPayload));
      }

      toast.success("Backup code verification successful!");
      navigate("/dashboard", { replace: true });
    } catch (error) {
      toast.error(error.response?.data?.message || "Invalid backup code");
      setLoading(false);
    }
  };

  return (
    <div className="container1">
      {loading && <Loading />}
      <div className="loginheader">
        <div className="d-flex gap-2 justify-content-center">
          <img
            alt=""
            src="/images/Union.png"
            style={{ width: "30px", height: "24px" }}
          />
          <h2 className="header">Pronto</h2>
        </div>
      </div>
      
      <div className="pcont">
        <div className="p-4">
          <div className="row">
            <div className="col-md-4 offset-md-4">
              <div className="text-center mb-4">
                <img
                  alt=""
                  src="/images/group.png"
                  style={{
                    width: "6rem",
                    height: "5rem",
                    display: "flex",
                    margin: "auto",
                  }}
                />
                <div className="textJ">Backup Code Verification</div>
                <div
                  className="textJ mt-2"
                  style={{ fontSize: "14px", fontWeight: "400", color: "#666" }}
                >
                  Enter one of your backup codes
                </div>
              </div>

              <div className="card p-4" style={{ backgroundColor: "white", borderRadius: "8px" }}>
                <form onSubmit={handleBackupVerification}>
                  <div className="mb-3">
                    <label className="form-label">Backup Code</label>
                    <input
                      type="text"
                      className="form-control text-center"
                      value={backupCode}
                      onChange={(e) => setBackupCode(e.target.value.toUpperCase())}
                      placeholder="Enter backup code"
                      style={{ fontSize: "1.2rem", letterSpacing: "0.2rem" }}
                      autoComplete="off"
                      autoFocus
                    />
                    <div className="form-text">
                      Enter one of the backup codes you saved when setting up 2FA
                    </div>
                  </div>

                  <div className="d-grid gap-2">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={!backupCode || loading}
                    >
                      {loading ? "Verifying..." : "Verify & Continue"}
                    </button>
                  </div>
                </form>

                <div className="text-center mt-3">
                  <button
                    className="btn btn-link"
                    onClick={() => navigate("/verify")}
                  >
                    Back to 2FA Code
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackupVerification;

